import React, { useEffect, useState } from 'react';
import { UserRound } from 'lucide-react';
import areaLogo from '../assets/area-logo.png';

export function Logo({ compact = false }) {
  return <span className={`artist-logo ${compact ? 'artist-logo--compact' : ''}`}><img className="artist-logo-image" src={areaLogo} alt="Area" width={1002} height={243} /></span>;
}

export function Avatar({ profile = {}, size = 48 }) {
  const name = profile.username || profile.displayName || profile.email?.split('@')[0] || 'Member';
  const [imageFailed, setImageFailed] = useState(false);
  useEffect(() => setImageFailed(false), [profile.photoURL]);
  return profile.photoURL && !imageFailed
    ? <img className="avatar" style={{ width: size, height: size }} src={profile.photoURL} alt={`${name}'s profile`} onError={() => setImageFailed(true)} />
    : <div className="avatar avatar--fallback" style={{ width: size, height: size }} role="img" aria-label={`${name}'s profile`}><UserRound size={Math.max(18, Math.round(size * 0.48))} aria-hidden="true" /></div>;
}

export function BookCover({ book = {}, className = '', onClick }) {
  const image = book.imageUrl || book.coverUrl || book.coverUrlResolved || book.coverUrlOriginal;
  const CoverElement = onClick ? 'button' : 'div';
  return (
    <CoverElement type={onClick ? 'button' : undefined} className={`book-cover ${className}`} onClick={onClick} aria-label={onClick ? book.name || book.title || 'Book' : undefined}>
      {image ? <img src={image} alt={`Cover of ${book.name || book.title}`} /> : <span>{(book.name || book.title || 'B').charAt(0)}</span>}
    </CoverElement>
  );
}

export function Spinner({ label = 'Loading' }) {
  return <div className="loading" role="status"><span className="spinner" /><span>{label}</span></div>;
}

export function EmptyState({ title, children, action }) {
  return <div className="empty-state"><h3>{title}</h3>{children && <p>{children}</p>}{action}</div>;
}

export function Modal({ title, onClose, children }) {
  return <div className="modal-backdrop" role="presentation" onMouseDown={onClose}><section className="modal" role="dialog" aria-modal="true" aria-label={title} onMouseDown={(event) => event.stopPropagation()}><header><h2>{title}</h2><button className="icon-button" onClick={onClose} aria-label="Close">×</button></header>{children}</section></div>;
}
